//animate circle charts
let charts = document.querySelectorAll('.chart')
if (charts.length > 0) {
    charts.forEach((chart) => {
        const circlePath = chart.querySelector('.circle')
        let range = parseInt(circlePath.getAttribute('data-range'), 10)
        if (range > 100) {
            range = 100
        }
        const totalCircleLength = circlePath.getTotalLength()
        console.log('totalCircleLength: ', totalCircleLength)

        circlePath.style.strokeDasharray = `${totalCircleLength}px`
        circlePath.style.strokeDashoffset = `${totalCircleLength}px`
    })
    const animateOnScroll = () => {
        charts.forEach((chart) => {
            const circlePath = chart.querySelector('.circle')
            let range = parseInt(circlePath.getAttribute('data-range'), 10)
            // if range is between 96 and 100, set range to 95. The circle has rounded corners and the stroke looks lite 100% otherwise.
            if (range > 95 && range < 100) {
                range = 95
            }
            const totalCircleLength = circlePath.getTotalLength()

            console.log('totalCircleLength: ', totalCircleLength)
            console.log('range: ', range)

            const chartPosition = chart.getBoundingClientRect()
            const viewportHeight = window.innerHeight

            if (chartPosition.top < viewportHeight * 0.8 && chartPosition.bottom > viewportHeight * 0.2) {
                animateCircle(circlePath, range, totalCircleLength)
            }
        })
    }
    window.addEventListener('scroll', animateOnScroll)
}

function animateCircle(circlePath, range, totalCircleLength) {
    const desiredOffset = (totalCircleLength * (100 - range)) / 100
    circlePath.style.transition = 'stroke-dashoffset 1s ease-in-out'
    circlePath.style.strokeDashoffset = `${desiredOffset}px`
}

// animate key-value numbers
document.addEventListener('DOMContentLoaded', (event) => {
    const numbers = document.querySelectorAll('.key-value-number')
    if (numbers.length > 0) {
        numbers.forEach((number) => {
            const endValue = parseInt(number.getAttribute('data-value'), 10)
            let startValue = 0
            const duration = 1500
            let startTime = performance.now()

            function updateNumber(currentTime) {
                if (!startTime) startTime = currentTime
                const elapsedTime = currentTime - startTime
                if (elapsedTime < duration) {
                    const rate = elapsedTime / duration
                    const current = startValue + (endValue - startValue) * rate
                    number.textContent = Math.round(current)
                    requestAnimationFrame(updateNumber)
                } else {
                    number.textContent = endValue
                }
            }

            requestAnimationFrame(updateNumber)
        })
    }
})

//add class to project menu on scroll
const projectMenu = document.querySelector('.project-menu')
const ul = document.querySelector('.project-menu ul')
if (projectMenu) {
    function handleScroll() {
        if (window.scrollY > 1) {
            projectMenu.classList.add('scrolled')
            projectMenu.classList.remove('container')
            ul.classList.add('container')
        } else {
            projectMenu.classList.remove('scrolled')
            projectMenu.classList.add('container')
            ul.classList.remove('container')
        }
    }
    handleScroll()
    window.addEventListener('scroll', handleScroll)
}

//rotate svg on scroll
document.addEventListener('scroll', function () {
    const rotation = window.scrollY / 20
    const rotatingElement = document.getElementById('rotatingSvg')
    if (rotatingElement) {
        rotatingElement.style.transform = 'rotate(' + rotation + 'deg)'
    }
})
